import axios from 'axios';
import {
    MDBBtn,
    MDBBtnGroup,
    MDBCard,
    MDBCardBody,
    MDBCardHeader,
    MDBCardText,
    MDBCol,
    MDBIcon,
    MDBRow,
    MDBTabs,
    MDBTabsItem,
    MDBTabsLink
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { DomainContext } from '../context/DomainProvider';
import { NavbarContext } from '../context/NavProvider';
import { UserProfileContext } from '../context/UserProfileProvider';
import { fetchMainPageData } from '../utils/Common';
import AddressFormModal from './AddressFormModal';
const AddressCard = ({address, addressesId, setAddresses,setActiveTab, activeTab, handleAddressModal, setAddressToUpdate, isCheckout ,isDelete}) => {
  
    const { setDomainData } = useContext(DomainContext);
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;
    const handleDelete = () => {
        axios
            .delete(`${baseUrl}/addresses/${addressesId}`, { data: [address.id] })
            .then(response => {
                if (response.status === 200) {
                   
                    setAddressToUpdate(null);  
                    setAddresses(prevAddresses => {
                        const updatedAddresses = prevAddresses.filter(addr => addr.id !== address.id);
                        if (updatedAddresses.length > 0) {
                            if (activeTab === address.type) setActiveTab(updatedAddresses[0].type);
                        } else {
                            
                            setDomainData({                               
                                addressIds: []
                               
                            });                         
                            setAddresses([]);
                          
                            setAddressToUpdate([]);                        
                           
                        }
                        return updatedAddresses; // Return the updated addresses array
                    });
                }
            })
            .catch(error => {
                
                if (error.response && error.response.status === 404) {
                    // Handling the case when the document is deleted and backend returns 404
                    setAddresses([]);
                    setAddressToUpdate([]);
                } else {
                    console.error(error);
                }
            });
    };
    
    
    
    const handleUpdate = useCallback(() => {
     
        handleAddressModal()
        setAddressToUpdate(address);
    }, []);

    return (
        <MDBCard>
            <MDBCardBody>
                <MDBCardText>{address?.street}</MDBCardText>
              <MDBCardText>{address?.locality}</MDBCardText>
              <MDBCardText>{address?.stateOrProvince} - {address?.postalCode} </MDBCardText>
               
                <MDBCardText>{address?.countryName}</MDBCardText>
                <MDBCardText>
  {address?.addressPurposes?.map((purpose, index, array) => (
    <p key={`${index}`}  className={index !== array.length - 1 ? 'me-2' : ''}>
      <MDBIcon fas icon="check" className='me-2' />{purpose}
    </p>
  ))}
</MDBCardText>

            </MDBCardBody>
        
           <MDBBtnGroup className='mb-2'> 
            <MDBBtn className='ms-2 me-2' color='primary' onClick={handleUpdate}>Update</MDBBtn>
            {isDelete &&  <MDBBtn className='me-2' color='success'  onClick={handleDelete}>Delete</MDBBtn> }
            </MDBBtnGroup>

         
         
        </MDBCard>
    );
};

AddressCard.propTypes = {
    isCheckout: PropTypes.bool,
    address: PropTypes.object,
    addressesId: PropTypes.string,
    setAddresses: PropTypes.func,
    setActiveTab: PropTypes.func,
    activeTab: PropTypes.string,
    handleAddressModal: PropTypes.func,  
    setAddressToUpdate: PropTypes.func,
    isDelete: PropTypes.object,
}


function AddressView({isCheckout}) {
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;
   
    const [addressToUpdate, setAddressToUpdate] = useState(null);
    const [showAddressModal, setShowAddressModal] = useState(false);
    const handleAddressModal = () => {setShowAddressModal(!showAddressModal)}; 
    const { setIsPricing,pageData,setPageData,setBusiness} = useContext(NavbarContext);
    const {domainData,setDomainData} = useContext(DomainContext);
    const { addresses, setAddresses, userProfile } = useContext(UserProfileContext); 
    const { domainId } = useParams();
   
    const addressIdForUserProfile = useMemo(() => userProfile?.street, [userProfile?.street]);
    const addressesId = addressIdForUserProfile || domainData?.addressIds?.[0] ;

    useEffect(() => {
        if (!pageData) {
          fetchMainPageData(setPageData,setIsPricing,pageData,setBusiness);
          
        }
      }, [pageData, setBusiness, setIsPricing, setPageData]);
      
    const handleClickAdd = () => {
        setAddressToUpdate(null); // Clear any data that is used to populate the modal fields
      handleAddressModal()
    };
   
    const [activeTab, setActiveTab] = useState(addresses && addresses[0] && addresses[0].type);
    const handleTabChange = (type) => {
        setActiveTab(type);
    }
    const deleteAll = () => {
        axios({
            method: 'delete',
            url: `${baseUrl}/addresses/all/${addressesId}/domain/${domainId}`,
        })
        .then(response => {
            if(response.status === 200) { 
                setAddressToUpdate(null);
             setDomainData({                        
                addressIds: []
            });
                                setAddresses([]);
                                setAddressToUpdate([]);
                              
               
            }
        })
        .catch(err => console.error(err));
    };
 
    
    return (
        <>
        <h5 className="display-8 fw-bold text-uppercase text-black mb-0 text-center" style={{ letterSpacing: '15px' }}> Addresses </h5>
 { domainId && addresses  && addresses?.length > 0 ?

 
  <MDBCol >
        <MDBCard className='text-center'>
      
           <MDBCardBody >
                {addresses  && addresses?.length>0 &&
            <MDBCardHeader background="light" className="text-center rounded">
                <MDBTabs className='card-header-tabs'>
                    {addresses?.map((address, index) => (
                        <MDBTabsItem key={index}>
                            <MDBTabsLink active={activeTab === address.type} onClick={() => handleTabChange(address.type)}>
                                {address.type}
                            </MDBTabsLink>
                        </MDBTabsItem>
                    ))}
                </MDBTabs>
            </MDBCardHeader> }
                <MDBRow className='justify-content-center'>
                    {addresses && addresses.length>0 && addresses?.map((address, index) => (
                        activeTab === address.type && (
                            <MDBCol  className='mb-4' key={index}>
                              
                                <AddressCard key={address.id}
        address={address} 
        addressesId={addressesId} 
        setAddresses={setAddresses}
        setActiveTab={setActiveTab}
        activeTab={activeTab}
        handleAddressModal={handleAddressModal} 
        setAddressToUpdate={setAddressToUpdate}    
       
    /> </MDBCol>)
    
    ))}
                </MDBRow>
                <MDBBtnGroup className="d-grid gap-2 d-md-block " style={{ marginBottom: '20px' }}>
            {/* <MDBBtn color='primary' block className="btn-lg py-3 px-5 mb-2 mb-md-4 me-md-2" onClick={() => setShowAddressModal(true)}>ADD</MDBBtn> */}
          
            <MDBBtn   color='warning'  className=" px-5 mb-2 mb-md-4 me-md-2" onClick={handleClickAdd}>{addresses?.length>0 ? 'ADD New Address' : 'ADD'}</MDBBtn> 

          { addresses?.length>0 &&   <MDBBtn color='success' className="px-5 mb-2 mb-md-4 me-md-2" onClick={deleteAll}>Delete All</MDBBtn>}
            </MDBBtnGroup>
            </MDBCardBody>

         
        </MDBCard>
       

</MDBCol>
                : 

<MDBCol className='text-center mb-2'>
            
           {isCheckout &&  <h5 className="text-primary mb-0 text-center" > Please verify if your billing and shipping Addresses are correct</h5> }
            <hr className="hr" />
            
                {addresses.length>0 &&
            <MDBCardHeader background="light" className="text-center rounded">
                <MDBTabs className='card-header-tabs'>
                    {addresses?.map((address, index) => (
                        <MDBTabsItem key={index}>
                            <MDBTabsLink active={activeTab === address?.type} onClick={(e) => { e.stopPropagation(); handleTabChange(address?.type)}}>
                                {address?.type}
                            </MDBTabsLink>
                        </MDBTabsItem>
                    ))}
                </MDBTabs>
            </MDBCardHeader> }
                <MDBRow className='justify-content-center'>
                    {addresses && addresses.length>0 && addresses?.map((address, index) => (
                        activeTab === address?.type && (
                            <MDBCol  className='mb-4' key={index}>
                              
                                <AddressCard isCheckout={isCheckout}
        address={address} 
        addressesId={addressesId} 
        setAddresses={setAddresses}
        setActiveTab={setActiveTab}
        activeTab={activeTab}
        handleAddressModal={handleAddressModal} 
        setAddressToUpdate={setAddressToUpdate}
        setShowAddressModal={setShowAddressModal}
        isDelete={addresses?.length>1}
       
    /> </MDBCol>)
    
    ))}
                </MDBRow>
           
           <MDBBtnGroup>
           <MDBBtn  color='warning'   onClick={handleClickAdd}>{addresses?.length>0 ? 'ADD New Address' : 'ADD'}</MDBBtn> 

           { addresses?.length>1 &&   <MDBBtn color='success'  onClick={deleteAll}>Delete All</MDBBtn>}

            </MDBBtnGroup>

        
          

        </MDBCol>}
{showAddressModal && 
<AddressFormModal 
                 addressIdForUserProfile={addressIdForUserProfile}   
showAddressModal={showAddressModal}
handleAddressModal={handleAddressModal} 
addressesId={addressesId}
setAddresses={setAddresses}
addresses={addresses}
addressToUpdate={addressToUpdate}
setShowAddressModal={setShowAddressModal}
isCheckout={isCheckout}


/>}
</>
    );
}

AddressView.propTypes = {
    isCheckout: PropTypes.bool
    }

export default AddressView;
